import { inputTextLimit } from '../../../helpers/fieldRestriction';
import messages from '../../../locale/jsonMessages';

const validate = (values, props) => {

  const errors = {}
  const activeLanguageCodes = props?.activeLanguageCodes || [];

  if (values?.dynamicPopularLocation) {
    let dynamicPopularLocationError = [];
    values.dynamicPopularLocation.map((item, index) => {
      const dynamicNameError = {};

      const isLanguageInactive = item?.language && activeLanguageCodes.length > 0
        && !activeLanguageCodes.includes(item.language);
      if (!item?.language || item?.language.toString().trim() === '' || isLanguageInactive) {
        dynamicNameError.language = messages.required;
        dynamicPopularLocationError[index] = dynamicNameError;
      }

      if (!item?.location || item?.location.toString().trim() === '') {
        dynamicNameError.location = messages.required;
        dynamicPopularLocationError[index] = dynamicNameError;
      } else if (item?.location?.length > inputTextLimit) {
        dynamicNameError.location = messages.inputTextLimitError;
        dynamicPopularLocationError[index] = dynamicNameError;
      }
    });
    if (dynamicPopularLocationError?.length > 0) errors.dynamicPopularLocation = dynamicPopularLocationError;
  }

  if (!values.locationAddress) {
    errors.locationAddress = messages.required;
  }
  if (!values.isEnable) {
    errors.isEnable = messages.required;
  }

  return errors
}

export default validate
